import { NgModule } from '@angular/core';

@NgModule({
    declarations: [],
    imports: [],
    exports: [],
    providers: [],
})
export class ModelModule {
}
